import type { ComponentSchema } from '../../../../../schema-types'
import { CONTENT_PAGES, SECTION_STYLE_FIELDS } from './_fields'

/** A swipe row of white parent-review cards: rating, quote, photo, name and role. */
export const schema: ComponentSchema = {
  type: 'testimonials',
  label: 'Testimonials',
  description: 'Parent reviews as white cards with rating, quote, photo, name and role.',
  supportedPages: CONTENT_PAGES,
  variants: [
    { id: 'v1', label: 'Review cards' },
  ],
  commonFields: [
    { key: 'title', label: 'Title', type: 'string', default: 'What parents say' },
    {
      key: 'items',
      label: 'Reviews',
      type: 'array',
      itemSchema: [
        { key: 'avatar', label: 'Photo', type: 'image' },
        { key: 'name', label: 'Name', type: 'string' },
        { key: 'designation', label: 'Who they are', type: 'string', placeholder: 'Mother of a 4-year-old, Dhaka' },
        { key: 'review', label: 'Review', type: 'text' },
        { key: 'rating', label: 'Rating (1–5)', type: 'number', default: 5 },
      ],
      default: [
        { name: 'Nusrat', designation: 'Mother of a 4-year-old, Dhaka', review: 'The building blocks came well packed and the pieces are smooth, no sharp edges. My son has played with them every day since.', rating: 5 },
        { name: 'Arif', designation: 'Father of two, Chattogram', review: 'Ordered two school bags on Sunday and paid on delivery on Tuesday. Strong zips and the sizes were exactly as listed.', rating: 5 },
        { name: 'Sadia', designation: 'New mum, Sylhet', review: 'The muslin wraps are soft and wash well. Helpful advice on the phone when I could not decide on a size.', rating: 4 },
      ],
    },
    ...SECTION_STYLE_FIELDS,
  ],
}
